import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CambiarClaveComponent } from '../cambiar-clave/cambiar-clave.component';
import { data } from 'jquery';
import { TokenService } from '@app/auth/token.service';
interface User{
  email: string,
  documento: string,
  nombreUsuario: string
}
@Component({
  selector: 'app-usuario-perfil',
  templateUrl: './usuario-perfil.component.html',
  styleUrls: ['./usuario-perfil.component.css']
})
export class UsuarioPerfilComponent implements OnInit {
 mensaje = '';
  documento: string;
  email: string;
  nombreUsuario: string;

  constructor( public dialog: MatDialog, public tokenService: TokenService) { }

  ngOnInit(): void {
    let user: User
    user = this.tokenService.getUser();

    this.documento = user.documento;
    this.email = user.email;
    this.nombreUsuario = user.nombreUsuario;
  }

  cambiarClaveDialog(): void {

    const dialogRef = this.dialog.open(CambiarClaveComponent , {
      width: '400px',
      data: { email: this.email}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       // this.cancelarZarpe();
      }
    });
}
}